import axios from "axios";
import router from "../routes";

import { server } from "../config.js";

let $api = axios.create({
  baseURL: server,
});

$api.interceptors.request.use(
  async (config) => {
    config.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("token");
    return config;
  },
  (err) => {
    return Promise.reject(err);
  },
);

$api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      router.push("/");
    }
    return Promise.reject(error);
  },
);

export default $api;
